var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vx-card',{staticClass:"top-zero-radius",attrs:{"no-shadow":""}})
}
var staticRenderFns = []

export { render, staticRenderFns }